{
  "title": "Dokumenter",
  "description": "Oversikt over alle dokumenter knyttet til denne skogeieren",
  "uploadButton": "Last opp nytt dokument",
  "newestFirst": "Nyeste først",
  "oldestFirst": "Eldste først",
  "selectPeriod": "Velg periode",
  "allTypes": "Vis alle typer",
  "loading": "Laster dokumenter...",
  "visible": "Synlig",
  "notVisible": "Ikke synlig",
  "columnDocument": "Dokument",
  "columnType": "Type",
  "typePowerOfAttorney": "Fullmaktsdokument",
  "typePropertyOwnership": "Eierskap og bruksrett",
  "columnVisible": "Synlig for skogeier",
  "columnUploadedBy": "Opplastet av",
  "columnUploadedDate": "Opplastet dato",
  "actionsDownload": "Last ned",
  "actionsEdit": "Endre",
  "actionsDelete": "Slett",
  "readOnlyTooltip": "Dokumentet administreres via registrering av representant og kan ikke endres eller slettes her",
  "readOnlyGenericTooltip": "Dokumentet er skrivebeskyttet og kan ikke endres eller slettes her",
  "readOnlyConflictMessage": "Dokumentet administreres via registrering av representant og kan ikke endres eller slettes her.",
  "deleteErrorMessage": "Kunne ikke slette dokumentet. Prøv igjen.",
  "editTitle": "Endre dokument",
  "uploadTitle": "Last opp nytt dokument",
  "uploadTypeLabel": "Type",
  "uploadTypePlaceholder": "Velg dokumenttype",
  "uploadFileLabel": "Last opp filer",
  "uploadFilesHelpText": "Velg dokumenttype før du velger fil.",
  "noFilesUploadedEmpty": "Ingen filer lastet opp",
  "uploadDescriptionLabel": "Beskrivelse",
  "uploadDescriptionPlaceholder": "Legg til en valgfri beskrivelse av dokumentet",
  "uploadVisibilityLabel": "Synlighet for skogeier",
  "uploadVisibilityDescription": "Velg om skogeier skal kunne se dokumentet eller ikke",
  "uploadVisibilityNotVisible": "Ikke synlig",
  "uploadVisibilityVisible": "Synlig",
  "documentTypeRequired": "Dokumentasjonstype må velges først",
  "uploadErrorMessage": "Noe gikk galt. Prøv igjen.",
  "editSaveButton": "Lagre endringer",
  "editFileLabel": "Last opp fil",
  "uploadedFilesLabel": "Opplastede filer",
  "abortDialogTitle": "Er du sikker på at du vil avbryte?",
  "abortDialogDescription": "Endringer du har gjort, inkludert opplastede filer og beskrivelser, vil ikke bli lagret.",
  "abortDialogCancel": "Fortsett redigering",
  "abortDialogAction": "Avbryt uten å lagre",
  "emptyTitle": "Ingen dokumenter",
  "emptyDescription": "Trykk på \"Last opp nytt dokument\" for å legge til et nytt",
  "emptyFilteredTitle": "Ingen dokumenter funnet",
  "emptyFilteredDescription": "Fant ingen dokumenter som matcher valgt periode eller type",
  "deleteFileDialogTitle": "Er du sikker på at du vil slette filen?",
  "deleteFileDialogDescription": "Denne handlingen kan ikke reverseres. Filen vil bli slettet permanent.",
  "deleteFileDialogCancel": "Avbryt",
  "deleteFileDialogAction": "Slett",
  "validationDocumentTypeRequired": "Dokumenttype må velges",
  "validationFileRequired": "Du må laste opp en fil",
  "validationFileMaxOne": "Bare én fil er tillatt",
  "validationDescriptionMaxLength": "Beskrivelsen kan ikke være mer enn 200 tegn"
}
